import React from 'react'
import styled from 'styled-components'
import { Modal } from 'antd'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { useEvents } from 'app/hooks/Events/event'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const EventDelete = ({ item }) => {
	const [modal, contextHolder] = Modal.useModal()
	const { deleteEvent } = useEvents()

	const confirm = () => {
		modal.confirm({
			title: '이벤트 삭제',
			content: '해당 이벤트를 삭제하시겠습니까?',
			okText: '삭제',
			okButtonProps: {
				type: 'primary',
				danger: true,
			},
			cancelText: '취소',
			onOk: async () => {
				await deleteEvent(item?.id)
			},
		})
	}

	return (
		<Wrapper>
			<CButton
				title="삭제"
				style={{
					background: 'linear-gradient(135deg, rgba(255, 106, 106, 0.95) 0%, rgba(255, 82, 123, 0.95) 100%)',
					color: COLORS.white,
					padding: '8px 18px',
					borderRadius: 999,
					fontWeight: 600,
					letterSpacing: 0.4,
				}}
				backgroundHover="linear-gradient(135deg, rgba(255, 130, 130, 1) 0%, rgba(255, 112, 150, 1) 100%)"
				onClick={confirm}
			/>
			{contextHolder}
		</Wrapper>
	)
}

export default EventDelete
